<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <Fan size="60" :power="power" :direction="availableFanDirections.indexOf(direction)"></Fan>
      </template>
      <template #value>{{ speedDisplay }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <FanControlDialog v-model="dialog" :power.sync="power" :speed.sync="speed" :direction.sync="direction" :availableFanSpeeds="availableFanSpeeds" :availableFanDirections="availableFanDirections" @setting="showSettingsDialog"></FanControlDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import FanControlDialog from '@/components/dialog/FanControlDialog'
import Fan from '@/components/icon/Fan'

export default {
  name: 'FanTile',
  mixins: [EndpointTile],
  components: {
    FanControlDialog,
    CenterizedTile,
    IconifiedTile,
    Fan
  },
  computed: {
    power: {
      get() {
        return this.report.on;
      },
      set(val) {
        if (this.report.on != val) {
          this.$set(this.report, 'on', val);
          this.$emit('command', {
            [this.endpointId]: {
              on: val
            }
          });
        }
      }
    },
    speed: {
      get() {
        return this.report.fanSpeed;
      },
      set(val) {
        if (this.report.fanSpeed != val) {
          this.$set(this.report, 'fanSpeed', val);
          this.$emit('command', {
            [this.endpointId]: {
              fanSpeed: val
            }
          });
        }
      }
    },
    direction: {
      get() {
        return this.report.fanDirection;
      },
      set(val) {
        if (this.report.fanDirection != val) {
          this.$set(this.report, 'fanDirection', val);
          this.$emit('command', {
            [this.endpointId]: {
              fanDirection: val
            }
          });
        }
      }
    },
    speedDisplay() {
      return this.speed ? this.$t(`fan.${this.speed}`) : '---';
    },
    availableFanSpeeds() {
      return ((this.info || {}).attributes || {}).availableFanSpeeds || [];
    },
    availableFanDirections() {
      return ((this.info || {}).attributes || {}).availableFanDirections || [];
    }
  }
}
</script>
